import React, { useState } from "react";
import { Modal, Row, Col, Button, Card } from "react-bootstrap";
import { Field, Form, Formik } from "formik";
import { useApolloClient, gql, useQuery } from "@apollo/client";
import Alert from "react-s-alert";

import { ContentLoading } from "../../../components/Loading";
import {
  Input,
  ImageUpload,
  ReactSwitch,
  ImageUploadCustom,
} from "../../../formik";
import ParticipantSwitch from "../../../formik/participants-switch";

const ParticipantsListForm = ({ intl, show, onHide, event_id }) => {
  const apolloClient = useApolloClient();
  const [formState, setFormState] = useState(null);

  const { data, loading } = useQuery(
    gql`
      query ($id: uuid!) {
        user_by_pk(id: $id) {
          name
          email
          password
          is_moderator
          disabled
          photo
          picture
        }
      }
    `,
    {
      variables: {
        id: show,
      },
      skip: show === true || !show,
      fetchPolicy: "network-only",
      onError: (err) => {
        // TODO
        alert("There was an error while fetching the user");
      },
    }
  );


  let userData = undefined
  
  if(data && data.user_by_pk && userData === undefined){
    userData = data
    console.log("user_by_pk if",data.user_by_pk);
    console.log("user_by_pk if",data);
   // userData.user_by_pk.disabled = ! data.user_by_pk.disabled
  }else{
    console.log("user_by_pk else",data);
  }
  

  return (
    <Modal className="list-modal-form" show={show} onHide={onHide}>
      <Modal.Header closeButton>
        <h4>
          {show !== true
            ? intl.formatMessage({ id: "edit.participant" })
            : intl.formatMessage({ id: "add.participant" })}
        </h4>
      </Modal.Header>
      <Modal.Body>
        {loading ? (
          <ContentLoading />
        ) : (
          <Formik
            initialValues={
              show !== true && userData
                ? {
                    ...userData.user_by_pk,
                    // password: ''
                  }
                : {
                    name: "",
                    email: "",
                    password: "",
                    photo: "",
                    is_moderator: false,
                    disabled: true,
                  }
            }
            onSubmit={async (values) => {
              try {
                if (show === true) {
                  // add form submission
                  Alert.closeAll();
                  setFormState("message.checking.email");
                  const emailCheck = await apolloClient.query({
                    query: gql`
                      query ($email: String, $event_id: String!) {
                        email: user(
                          where: {
                            email: { _eq: $email }
                            event_id: { _eq: $event_id }
                          }
                        ) {
                          id
                        }
                      }
                    `,
                    variables: {
                      email: values.email,
                      event_id,
                    },
                    fetchPolicy: "network-only",
                  });

                  if (emailCheck.data.email.length > 0) {
                    throw new Error(
                      intl.formatMessage({ id: "error.email-taken" })
                    );
                  }

                  // create the user
                  setFormState("message.creating.user");
                  await apolloClient.mutate({
                    mutation: gql`
                      mutation ($object: user_insert_input!) {
                        insert_user_one(object: $object) {
                          id
                        }
                      }
                    `,
                    variables: {
                      object: {
                        ...values,
                        source: "manual",
                        event_id,
                      },
                    },
                  });
                  Alert.success(
                    intl.formatMessage({ id: "message.user-created" })
                  );
                  onHide();
                } else {
                  // edit form submission
                  Alert.closeAll();
                  setFormState("message.checking.email");
                  const emailCheck = await apolloClient.query({
                    query: gql`
                      query ($id: uuid!, $email: String, $event_id: String!) {
                        email: user(
                          where: {
                            email: { _eq: $email }
                            id: { _neq: $id }
                            event_id: { _eq: $event_id }
                          }
                        ) {
                          id
                        }
                      }
                    `,
                    variables: {
                      email: values.email,
                      id: show,
                      event_id,
                    },
                    fetchPolicy: "network-only",
                  });

                  if (emailCheck.data.email.length > 0) {
                    throw new Error(
                      intl.formatMessage({ id: "error.email-taken" })
                    );
                  }

                  // create the user
                  setFormState("message.updating.user");
                  
                  const { __typename, password, ..._set } = values;
                  if (password) {
                    _set.password = password;
                  }
                  await apolloClient.mutate({
                    mutation: gql`
                      mutation ($id: uuid!, $_set: user_set_input) {
                        update_user_by_pk(
                          pk_columns: { id: $id }
                          _set: $_set
                        ) {
                          id
                        }
                      }
                    `,
                    variables: {
                      id: show,
                      _set,
                    },
                  });
                  Alert.success(
                    intl.formatMessage({ id: "message.user-updated" })
                  );
                  onHide();
                }
              } catch (e) {
                Alert.error(intl.formatMessage({ id: e.message }));
              }

              setFormState(false);
            }}
          >
            {({ values }) => {
              return (
                <Form className="add-event-form ">
                  <Field
                    name="name"
                    type="name"
                    id="name"
                    placeholder={intl.formatMessage({ id: "input.name" })}
                    component={Input}
                    required
                  />
                  <Field
                    name="email"
                    type="email"
                    id="email"
                    placeholder={intl.formatMessage({ id: "input.email" })}
                    component={Input}
                    required
                  />
                  <Field
                    name="password"
                    type="password"
                    id="password"
                    placeholder={intl.formatMessage({
                      id:
                        show === true ? "input.password" : "input.password-new",
                    })}
                    component={Input}
                    minLength={6}
                    required={show === true}
                  />
                  <div
                    className="form-group "
                    style={{
                      margin: "0px 135px 30px 135px",
                    }}
                  >
                    <Card className="img-upload bg-gray">
                      <Card.Body>
                        <Field
                          component={ImageUploadCustom}
                          id="picture"
                          name="picture"
                          defaultImage="/images/profile-ico-img.png"
                          accept="image/*"
                          buttonEmpty="label.uploadPhoto"
                          buttonUploaded={intl.formatMessage({
                            id: "label.logoUploaded",
                          })}
                          maxSize={process.env.REACT_APP_IMAGE_FILE_SIZE_MAX}
                        />
                      </Card.Body>
                    </Card>
                  </div>
                  <Row>
                    <Col>
                      <Field
                        component={ReactSwitch}
                        name="is_moderator"
                        id="is_moderator"
                        label={intl.formatMessage({
                          id: "input.audience.moderator",
                        })}
                       
                        offColor="#b1b1b1"
                        onColor="#f9962e"
                      />
                    </Col>
                    <Col>
                      <Field
                        component={ParticipantSwitch}
                        name="disabled"
                        id="disabled"
                        offColor="#b1b1b1"
                        onColor="#f9962e"
                        label={intl.formatMessage({
                          id: values.disabled
                            ? "input.audience.blocked"
                            : "input.audience.unblocked",
                        })}
                      />
                    </Col>
                  </Row>
                  <Row>
                    <Col>
                      <div className="form-buttons m-t-30 m-b-30 text-center">
                        <Button onClick={onHide} className="btn-black">
                          {intl.formatMessage({
                            id: "button.back",
                          })}
                        </Button>
                        <Button
                          type="submit"
                          className="btn-custom m-l-20 btn btn-primary"
                          disabled={!!formState}
                        >
                          {show !== true &&
                            intl.formatMessage({
                              id: formState ? formState : "edit",
                            })}
                          {show === true &&
                            intl.formatMessage({
                              id: formState ? formState : "button.add",
                            })}
                        </Button>
                      </div>
                    </Col>
                  </Row>
                </Form>
              );
            }}
          </Formik>
        )}
      </Modal.Body>
    </Modal>
  );
};

export default ParticipantsListForm;
